<template>
  <v-dialog
    v-model="value"
    persistent
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="handleCloseDialog"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            dark
            text
            @click="handleUpdate"
          >
            Save
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container>
        <v-card class="pl-5 pr-5 pb-5 mb-5">
          <div class="mt-2 pt-2">
            <table class="mb-2">
              <tr>
                <td>Coach:</td>
                <td>{{ userRecord.fullName || '' }}</td>
              </tr>
              <tr>
                <td>Join Date:</td>
                <td>{{ formatDate(record.joinDate) }}</td>
              </tr>
              <tr>
                <td>Email:</td>
                <td>{{ userRecord.email || '' }}</td>
              </tr>
              <tr>
                <td>Mobile:</td>
                <td>{{ userRecord.mobileNo || '' }}</td>
              </tr>
              <tr>
                <td>Position:</td>
                <td>{{ record.position || '' }}</td>
              </tr>
            </table>
            <div class="mb-4">
              <universal-input
                :ref="basicSalaryRef"
                v-model="basicSalary"
                :config="basicSalaryConfig"
              />
            </div>
          </div>
          <div class="mt-5">
            <div>
              Commission Schemas:
              <span><v-btn
                class="ml-5"
                icon
                color="primary"
                small
                @click="handleCreate"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn></span>
            </div>
            <!-- <div class="remark">
              <span
                class="activated-mark"
              >*</span><span>: Activated Commisssion Schema</span>
            </div> -->
            <div
              v-if="coachCommissionSchemaList.length==0"
              class="pb-5"
            >
              No Schema
            </div>
            <v-form
              ref="form"
              lazy-validation
            >
              <v-row>
                <v-col
                  v-for="(coachCommissionShema,index) in coachCommissionSchemaList"
                  :key="coachCommissionShema.id"
                  cols="6"
                  sm="12"
                  md="12"
                  lg="6"
                >
                  <v-card class="pb-2">
                    <v-card-title>
                      <span>
                        {{ getSchemaNameByID(coachCommissionSchemaList[index].commissionSchemaTypeID) }}
                      </span>
                      <universal-input
                        v-model="coachCommissionSchemaList[index].isActivated"
                        style="margin-top: -5px;"
                        :config="coachCommissionSchemaList[index].isActivatedConfig"
                      />
                      <v-spacer></v-spacer>
                      <v-icon
                        @click="handleRemove(index)"
                      >
                        mdi-trash-can
                      </v-icon>
                    </v-card-title>
                    <div class="px-5 mb-2">
                      <div class="mb-2">
                        <universal-input
                          v-model="coachCommissionSchemaList[index].commissionSchemaTypeID"
                          :config="coachCommissionSchemaList[index].commissionSchemaTypeIDConfig"
                          @update="(e)=>handleCommissionSchemaTypeChange(coachCommissionSchemaList[index],e)"
                        />
                      </div>
                      <div
                        v-if="coachCommissionSchemaList[index].commissionSchemaType?coachCommissionSchemaList[index].commissionSchemaType.byCommissionCenter:false"
                        class="pl-2 mb-5"
                      >
                        <div>Centers:</div>
                        <v-row no-gutters>
                          <v-col
                            v-for="center in centerList"
                            :key="center.id"
                            cols="2"
                            sm="6"
                            md="3"
                            lg="2"
                          >
                            <v-checkbox
                              :input-value="coachCommissionSchemaList[index].selectedCenters"
                              :label="center.code"
                              hide-details
                              :value="center.id"
                              @change="(value)=>{updateCenter(center,coachCommissionSchemaList[index].selectedCenters)}"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </div>
                      <div class="mb-2">
                        <universal-input
                          v-model="coachCommissionSchemaList[index].effectiveDate"
                          :config="coachCommissionSchemaList[index].effectiveDateConfig"
                        />
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
          </div>
        </v-card>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script setup>
import { ref, onMounted, computed, toRefs, watch, nextTick } from 'vue'
import UniversalInput from '@/components/CRUD/UniversalInput.vue'
import { loading, formatDate, handleSelectionResponse } from '@/utils/helper'
import { updateCoachCommissionSchema } from '@/api/coach'
import InputContainer from '@/components/CRUD/InputContainer.vue'
import { fetchList as fetchCenter } from '@/api/center'
import { fetchList as fetchSchemaType } from '@/api/commissionSchemaType'
import { updateSchemas } from '@/api/coachCommissionSchema'
import { getItem, updateItem } from '@/api/coachInfo'
import moment from '@/utils/moment'

const form = ref(null)
const basicSalaryRef = ref(null)
const basicSalary = ref(0)
const basicSalaryConfig = ref({
  propName: 'basicSalary',
  label: 'Basic Salary:',
  type: {
    name: 'text',
    inputType: 'number',
  },
})
const title = ref('Coach Commission Schema')

const commissionSchemaTypeIDConfig = {
  propName: 'commissionSchemaTypeID',
  label: 'Commission Schema',
  type: {
    name: 'autocomplete',
    items: [],
  },
}

const centerConfig = {
  propName: 'centerID',
  label: 'Center',
  type: {
    name: 'select',
    items: [],
  },
}

const isActivatedConfig = {
  propName: 'isActivated',
  type: {
    name: 'switch',
    hideDetails: true,
  },
}
const effectiveDateConfig = {
  propName: 'effectiveDate',
  label: 'Effective Date',
  type: {
    name: 'datepicker',
    hideDetails: true,
  },
}

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  userRecord: {
    type: Object,
    default: () => ({
      id: -1,
      fullName: '',
      email: '',
      joinDate: '0001-01-01T00:00:00.000Z',
      mobileNo: '',
      coachInfo: {
        userRecordID: -1,
        position: 'Full Time Coach',
        joinDate: '0001-01-01T00:00:00.000Z',
        basicSalary: 0,

        // salesTarget: 0,
        id: -1,
      },
    }),
  },
})
const emits = defineEmits(['input', 'close'])
function handleCloseDialog() {
  console.log('handleCloseDialog')
  emits('input', false)
  emits('close')
}

const { userRecord } = toRefs(props)

const defaultRecord = {
  userRecordID: -1,
  position: 'Full Time Coach',
  joinDate: '0001-01-01T00:00:00.000Z',
  basicSalary: 0,

  // salesTarget: 0,
  id: -1,
  coachCommissionSchemas: [],
  selectedCenters: [],
}
const record = ref({ ...defaultRecord })

const centerList = ref([])

const schemaTypeList = ref([])
fetchCenter({
  page: 0,
  limit: 0,
}).then(res => {
  console.log('center res', res)
  centerList.value = handleSelectionResponse(res)

  centerConfig.type.items = [...centerList.value]
  console.log('centerList.value', centerList.value)
  console.log('centerConfig', centerConfig)
})

fetchSchemaType({
  page: 0,
  limit: 0,
}).then(res => {
  console.log('fetchCoreSchema res', res)
  schemaTypeList.value = handleSelectionResponse(res, 'name', clone => {
    const item = clone
    if (item.salesTarget > 0) {
      item.label = `${item.name} (Target: ${item.salesTarget})`
    }

    return item
  })
  commissionSchemaTypeIDConfig.type.items = [...schemaTypeList.value]
  console.log('schemaTypeList.value', schemaTypeList.value)
  console.log('commissionSchemaTypeIDConfig', commissionSchemaTypeIDConfig)
})
const defaultCoachComissionSchema = {
  coachInfoID: -1,
  commissionSchemaTypeID: -1,
  isActivated: false,
  effectiveDate: '0001-01-01T00:00:00.000Z',
  coachCommissionCenters: [],
  selectedCenters: [],
}
const coachCommissionSchemaList = ref([])

function getInfo(id) {
  getItem(id).then(res => {
    console.log('coachInfo res', res)
    record.value = res.data.record

    for (let index = 0; index < record.value.coachCommissionSchemas.length; index += 1) {
      const coachCommissionSchema = record.value.coachCommissionSchemas[index]
      coachCommissionSchema.commissionSchemaTypeIDConfig = JSON.parse(JSON.stringify(commissionSchemaTypeIDConfig))
      coachCommissionSchema.effectiveDateConfig = { ...effectiveDateConfig }
      coachCommissionSchema.isActivatedConfig = JSON.parse(JSON.stringify(isActivatedConfig))
      const temp = coachCommissionSchema.isActivated
      coachCommissionSchema.isActivated = false
      console.log('temp coachCommissionSchema.isActivated', temp, coachCommissionSchema.isActivated)
      nextTick(() => {
        coachCommissionSchema.effectiveDate = formatDate(coachCommissionSchema.effectiveDate)
        coachCommissionSchema.isActivated = temp
        console.log('temp coachCommissionSchema.isActivated', temp, coachCommissionSchema.isActivated)
      })
      coachCommissionSchema.selectedCenters = []
      for (let centerIndex = 0; centerIndex < coachCommissionSchema.coachCommissionCenters.length; centerIndex += 1) {
        const coachCommissionCenter = coachCommissionSchema.coachCommissionCenters[centerIndex]

        // coachCommissionCenter.centerConfig = JSON.parse(JSON.stringify(centerConfig))
        nextTick(() => {
          coachCommissionSchema.selectedCenters.push(coachCommissionCenter.centerID)
        })
      }
    }
    basicSalary.value = record.value.basicSalary

    // salesTarget.value = record.value.salesTarget
    console.log('coachInfo record.value', record.value)

    coachCommissionSchemaList.value = [...record.value.coachCommissionSchemas]
  })
}

watch(userRecord, newVal => {
  console.log('userRecord', newVal)
  if (newVal.coachInfo && newVal.coachInfo.id > 0) {
    getInfo(newVal.coachInfo.id)
  }
})

function handleCreate() {
  const defaultItem = JSON.parse(JSON.stringify(defaultCoachComissionSchema))

  // set input config
  defaultItem.commissionSchemaTypeIDConfig = JSON.parse(JSON.stringify(commissionSchemaTypeIDConfig))
  defaultItem.effectiveDateConfig = { ...effectiveDateConfig }
  defaultItem.isActivatedConfig = JSON.parse(JSON.stringify(isActivatedConfig))

  // set center config
  for (let index = 0; index < defaultItem.coachCommissionCenters.length; index += 1) {
    const coachCommissionCenter = defaultItem.coachCommissionCenters[index]
    coachCommissionCenter.centerConfig = JSON.parse(JSON.stringify(centerConfig))
  }
  defaultItem.coachInfoID = record.value.id
  coachCommissionSchemaList.value.push(defaultItem)
  nextTick(() => {
    coachCommissionSchemaList.value[coachCommissionSchemaList.value.length - 1].commissionSchemaTypeID = schemaTypeList.value[0].id
    coachCommissionSchemaList.value[coachCommissionSchemaList.value.length - 1].effectiveDate = moment().format('YYYY-MM-DD')
    coachCommissionSchemaList.value[coachCommissionSchemaList.value.length - 1].isActivated = false
  })
}

function handleRemove(index) {
  coachCommissionSchemaList.value.splice(index, 1)
}

function getSchemaByID(id) {
  return schemaTypeList.value.find(schemaType => schemaType.id === id)
}

function getSchemaNameByID(id) {
  const item = getSchemaByID(id)
  if (item) {
    return item.name
  }

  return ''
}

function getSalesTargetByID(id) {
  const item = getSchemaByID(id)
  console.log('getSalesTargetByID', item)
  if (item) {
    return item.salesTarget
  }

  return 0
}

function handleUpdate() {
  console.log('handle update')
  if (form.value.validate()) {
    record.value.basicSalary = basicSalary.value
    record.value.coachCommissionSchemas = [...coachCommissionSchemaList.value]

    // convert selected center to coachCommissionCenter
    for (let index = 0; index < record.value.coachCommissionSchemas.length; index += 1) {
      const coachCommissionSchema = record.value.coachCommissionSchemas[index]
      if (coachCommissionSchema.selectedCenters.length > 0) {
        coachCommissionSchema.coachCommissionCenters = []
        coachCommissionSchema.selectedCenters.forEach(centerID => {
          coachCommissionSchema.coachCommissionCenters.push({
            centerID,
            coachCommissionSchemaID: coachCommissionSchema.id,
          })
        })
      }
    }
    console.log('record', record.value)

    loading(true)
    updateSchemas(record.value).then(res => {
      console.log('res', res)

      // record.value = { ...defaultRecord }

      handleCloseDialog()

      getInfo(userRecord.value.coachInfo.id)
    }).catch(err => {
      console.log('err', err)
    }).finally(() => {
      loading(false)
    })
  }
}

function updateCenter(center, centerArr) {
  console.log('updateCenter', centerArr, center)
  let push = true
  if (centerArr.length > 0) {
    const index = centerArr.findIndex(item => item === center.id)
    if (index >= 0) {
      centerArr.splice(index, 1)
      push = false
    }
  }
  if (push) {
    centerArr.push(center.id)
  }
  console.log('updateCenter', centerArr)
}

function handleCommissionSchemaTypeChange(item) {
  const itemRef = item
  itemRef.commissionSchemaType = getSchemaByID(item.commissionSchemaTypeID)
}

</script>

<style scoped>
.remark{
  font-size: 8px;
  color: #999;
}
</style>

<style >
.activated-mark{
  color:red !important;
}
</style>
